module.exports = __webpack_public_path__ + "static/img/fish14.e23f2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish14.png
// module id = 5kQw
// module chunks = 0